import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore.jsx';
import { useEffect } from 'react';
import { hasRole, isSuperAdmin as checkIsSuperAdmin, isAdmin as checkIsAdmin, debugUserRoles } from '../utils/authUtils.js';

const useAuth = () => {
  const navigate = useNavigate();
  
  const {
    isAuthenticated,
    user,
    loading,
    error,
    initLogin,
    login,
    logout,
    refreshToken,
    getMe,
    clearError,
    initialize,
  } = useAuthStore();

  // 앱 초기화 시 토큰 복구
  useEffect(() => {
    initialize();
  }, [initialize]);

  // 로그인 처리
  const handleLogin = async (credentials) => {
    try {
      const response = await login(credentials);
      
      if (response && !response.error) {
        return { success: true, data: response };
      } else {
        return { success: false, error: response.error };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // 로그아웃 처리
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {

      // 실패해도 로그인 페이지로 이동
      navigate('/login', { replace: true });
    }
  };

  // 로그인 페이지로 이동
  const moveToLogin = (returnUri) => {
    const path = returnUri ? `/login?returnUri=${encodeURIComponent(returnUri)}` : '/login';
    navigate(path, { replace: true });
  };

  // 특정 경로로 이동
  const moveToPath = (path) => {
    navigate(path, { replace: true });
  };

  // 토큰 갱신 처리
  const handleRefreshToken = async () => {
    try {
      const success = await refreshToken();
      if (!success) {
        moveToLogin();
      }
      return success;
    } catch (error) {

      moveToLogin();
      return false;
    }
  };

  // 사용자 역할 확인 유틸리티 (authUtils 사용)
  const hasUserRole = (role) => {
    return hasRole(user, role);
  };

  const isSuperAdmin = () => {
    const result = checkIsSuperAdmin(user);
    // 개발 환경에서 디버깅
    if (process.env.NODE_ENV === 'development' && user) {
      debugUserRoles(user);
    }
    return result;
  };
  
  const isAdmin = () => checkIsAdmin(user);

  return {
    // 상태
    isAuthenticated,
    user,
    loading,
    error,
    
    // 액션
    initLogin,
    login: handleLogin,
    logout: handleLogout,
    refreshToken: handleRefreshToken,
    getMe,
    clearError,
    
    // 유틸리티
    moveToLogin,
    moveToPath,
    hasRole: hasUserRole,
    isSuperAdmin,
    isAdmin,
  };
};

export default useAuth;
